import React from 'react';

const Header = () => {
    return (
        <h1 style={{ marginBottom: '50px', textAlign: 'center' }}>Reviews list</h1>
    )
}

export default Header; 